import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

interface Context {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
  appId: string;
}

export const initLogging = (): void => {
  if (process.env.DATA_DOG_LOG_CLIENT_TOKEN) {
    datadogLogs.init({
      clientToken: process.env.DATA_DOG_LOG_CLIENT_TOKEN,
      forwardErrorsToLogs: true,
      sampleRate: 100,
    });

    datadogLogs.addLoggerGlobalContext('service', 'addon-trace-frontend');
  }
};

export const initRum = (): void => {
  if (process.env.DATA_DOG_RUM_APP_ID && process.env.DATA_DOG_RUM_CLIENT_TOKEN) {
    datadogRum.init({
      applicationId: process.env.DATA_DOG_RUM_APP_ID,
      clientToken: process.env.DATA_DOG_RUM_CLIENT_TOKEN,
    });
  }
};

export const setLoggingContext = (context: Context): void => {
  if (process.env.DATA_DOG_CLIENT_TOKEN) {
    Object.entries(context).forEach(([key, value]) => {
      datadogLogs.addLoggerGlobalContext(key, value);
    });
  }
};

export const setRumContext = (context: Context): void => {
  if (process.env.DATA_DOG_RUM_APP_ID && process.env.DATA_DOG_RUM_CLIENT_TOKEN) {
    Object.entries(context).forEach(([key, value]) => {
      datadogRum.addRumGlobalContext(key, value);
    });
  }
};
